import * as React from 'react';
import Loader from "@elsa-zku/lib/components/Loader";
import Header from "src/components/Header";
import { useUser } from "src/store/user";

type Props = {
  children: () => JSX.Element,
};

export default function UserAuthGuard(props: Props): JSX.Element {
  const user = useUser();

  if (!user) return <Loader />;
  return (
    <>
      <Header />
      {props.children()}
    </>
  )
};
